import styled, { css } from "styled-components";

const DeliveryBackupStyled = styled.div`

 & > button {
	margin-top: 0px !important;
 }

 .backupSectionWrapper{
	display: flex;
	flex-direction: column;
	gap: 24px;
 }

 .backupCardWrapper{
	margin-top:2.4rem;
	display: flex;
	flex-direction: column;
	gap: 24px;
 }

 @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
	.backupCardWrapper{
	flex-direction: row;
 }
        }

 .addBackupWrapper{
	display: flex;
	font-size: 1.6rem;
	font-weight: 700;
	align-items: center;
	gap: 8px;
	color: #008755;
	font-family: ${props => props.theme.fonts.heading};
	cursor: pointer;
 }

 .overviewWrapper {
	margin: 2.4rem 0;
	display: flex;
	flex-direction: column;
	gap: 24px;
	padding: 20px;
	max-width: 700px;
	border: 1px solid #CFD0CF;
	border-radius: 5px;
 }

 .overviewTextWrapper{
	display: flex;
	flex-direction: column;
	gap: 8px;
	
 }

 .overviewTitle {
	font-size: 1.8rem;
	font-family: ${props => props.theme.fonts.heading};
	font-weight: 700;
	color: #1B1E1C;
 }

 .overviewText { 
	font-size: 1.4rem;
	font-weight: 400;
	color: #757575;
 }

 .addBackupTextHandler {
	font-size: 1.6rem;
	font-weight: 700;
	color: #008755;
	font-family: ${props => props.theme.fonts.heading};
	display: flex;
	gap: 8px;
	align-items: center;
	cursor: pointer;
 }


`;

const ModalWrapperStyled = styled.div`

display: flex;
flex-direction: column;
gap: 40px;

.infoWrapper {
	display: flex;
	flex-direction: column;
	gap: 32px;
}

.modalAddress {
	display:flex;
	flex-direction: column;
	line-height: 22px;
}

.modaltext{
	font-size: 1.7rem;
	font-weight: 400;
	color: #1B1E1C;
}

.title {
	font-weight: 700;
}

.backupWrapper {
	display: flex;
	flex-direction: column;
}

.buttonWrapper {
	display: flex;
	gap: 24px;
 }

 .modalButton {
	
	border-radius: 5px;
	font-size: 1.6rem;
	font-weight: 700;
	font-family: ${props => props.theme.fonts.heading};
	padding: 16px;
	width: 120px;
	text-align: center;


 }

 .cancelButton {
	border: 1px solid #008755;
	color: #1B1E1C;
 }

 .deleteButton {
	background-color: #D22630;
	color: white;
 }
`;

export {
	DeliveryBackupStyled, ModalWrapperStyled
};